import { UserStoreInitializer } from 'hooks/useInitializeUserStore';
import { CreateModifyProvider } from 'providers/CreateModifyProvider';
import { DialogTriggerProvider } from 'providers/DialogTriggerProvider';
import { GlobalDialogProvider } from 'providers/GlobalDialogProvider';
import { NotificationProvider } from 'providers/NotificationProvider';
import { combineProviders } from 'utils/contextUtils';

const EDealerProvider = combineProviders([
  GlobalDialogProvider,
  DialogTriggerProvider,
  UserStoreInitializer,
  NotificationProvider,
  CreateModifyProvider,
]);

export default EDealerProvider;
